module.exports = {
  // 页面信息
  getPageInfos (state) {
    return state.pageInfo
  },
  getUserInfo (state) {
    // 用户信息
    return state.userInfo
  }
}



// WEBPACK FOOTER //
// ./src/store/global/getters.js